const actions = {
  SET_STATE: 'userDevice/SET_STATE',
  FETCH_USER_DEVICES: 'userDevice/FETCH_USER_DEVICES',
}

export default actions
